import { render } from "./empty-text.vue?vue&type=template&id=015aeb85"
import script from "./empty-text.vue?vue&type=script&lang=js"
export * from "./empty-text.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__